import React, {useEffect} from 'react'
import './Progetti.css'
import {NavLink} from 'react-router-dom'
import Intro_Image from "./Img/Intro-image.png"

const Progetti = () => {

    useEffect(() => {
        let title = document.getElementsByTagName('title')[0]
        title.innerHTML = "Progetto 4C | Nostri Progetti"
        window.scrollTo(0,0)
    }, [])

  return (
    <div>
        {/* === sotto nav bar === */}

        <div className='row under-nav d-flex justify-content-center align-items-center mt-5'>
            <div className="col-xl-4 col-lg-4 col-md-7 col-sm-10 col-11 d-flex justify-content-center align-items-center order-lg-1 order-xl-1 order-2 pt-lg-0 pt-xl-0 pt-4" data-aos="fade-up" data-aos-delay="400">
                <div>
                    <h1 className='sub-under-nav'>| Progetti<br/> Trova tutti i progetti creati dalla 4C ITIS INFO anno 2022/23</h1>
                    <p className='txt-under-nav mt-3'>
                        In questa pagine troveri tutti i progetti che sono stati svolti dagli studenti della 4C ITIS INFO Rrivoira nell'anno scolastico 2022/23
                    </p>

                    <div className='d-flex justify-content-lg-start justify-content-xl-start justify-content-md-center justify-content-sm-center justify-content-center mb-3'>
                        <NavLink className='btn-esplora col-6' style={{textDecoration:"none", color:"white"}} to={"/"}> <strong>Torna Alla Home</strong> </NavLink>
                    </div>
                </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-9 col-10 mt-5 d-flex justify-content-center order-1 order-lg-2 order-xl-2 mt-5" data-aos="zoom-in" data-aos-delay="400">
                <img src={Intro_Image} alt="" className='img-fluid flaoting res-intro-image'/>
            </div>
        </div>

        <svg width="100%" height="100%" id="svg" viewBox="0 0 1440 310" xmlns="http://www.w3.org/2000/svg" className="mw transition duration-300 ease-in-out delay-150">
            <path d="M 0,400 C 0,400 0,200 0,200 C 198.13333333333333,154.66666666666669 396.26666666666665,109.33333333333334 529,128 C 661.7333333333333,146.66666666666666 729.0666666666667,229.33333333333331 870,252 C 1010.9333333333333,274.6666666666667 1225.4666666666667,237.33333333333334 1440,200 C 1440,200 1440,400 1440,400 Z" stroke="none" strokeWidth="0" fill="#0104a3" fillOpacity="1" className="transition-all duration-300 ease-in-out delay-150 path-0" transform="rotate(-180 720 200)"></path>
        </svg>

        {/* === sotto nav bar === */}


        <div className='row justify-content-center cont-prog p-3'>
            <h2 className='tit col-12 d-flex justify-content-center tx-al mb-4' data-aos="fade-right">Progetti Scolastici</h2>
            

            {/* PROGETTI APICE */}
            <div className="col-12 d-flex justify-content-center aling-items-center" data-aos="fade-right">

                <div className="card-pr col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 mb-5">

                    <div className="header d-flex justify-content-center">
                        <span className="icon">
                            <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path clipRule="evenodd" d="M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z" fillRule="evenodd"></path>
                            </svg>
                        </span>
                        <p className="alert">Presentazioni Apice</p>
                    </div>

                    <p className="message d-flex justify-content-center">
                        Presentazione svolta in occassione dell'incontro con Luca Giordana esponente APICE.
                    </p>

                    <div className="actions d-flex justify-content-center">
                        <NavLink className='btn-esplora col-xl-10 mb-3' style={{textDecoration:"none", color:"white"}} to={"/Progetti/Apice"}> <strong>Visualizza Progetti</strong> </NavLink>
                    </div>

                </div>

            </div>


            {/* PROGETTI TKINTER */}
            <div className="col-12 d-flex justify-content-center aling-items-center" data-aos="fade-right">

                <div className="card-pr col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 mb-5">

                    <div className="header d-flex justify-content-center">
                        <span className="icon">
                            <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path clipRule="evenodd" d="M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z" fillRule="evenodd"></path>
                            </svg>
                        </span>
                        <p className="alert">Presentazioni Tkinter</p>
                    </div>

                    <p className="message d-flex justify-content-center">
                        Presentazione svolta dagli studenti della classe su 20 widgets scelti e assegnati dai prof d'informatica.
                    </p>

                    <div className="actions d-flex justify-content-center">
                        <NavLink className='btn-esplora col-xl-10 mb-3' style={{textDecoration:"none", color:"white"}} to={"/Progetti/Tkinter"}> <strong>Visualizza Progetti</strong> </NavLink>
                    </div>

                </div>

            </div>

        </div>

        
        <h5 className='mt-3 style-name-locali'><strong></strong></h5>
        

    </div>
  )
}

export default Progetti